// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

type AlignX = 'left' | 'center' | 'right' | 'between' | 'around';
type AlignY = 'top' | 'center' | 'bottom' | 'stretch';

interface RowProps extends React.ComponentPropsWithRef<'div'> {
  gap?: number;
  alignX?: AlignX;
  alignY?: AlignY;
  isWrap?: boolean;
}

export default styled.div<RowProps>`
  display: flex;
  flex-direction: row;

  ${({ isWrap }) => {
    if (isWrap) {
      return 'flex-wrap: wrap;';
    }
  }}

  ${({ alignX }) => {
    switch (alignX) {
      case 'left':
        return 'justify-content: flex-start;';
      case 'center':
        return 'justify-content: center;';
      case 'right':
        return 'justify-content: flex-end;';
      case 'between':
        return 'justify-content: space-between;';
      case 'around':
        return 'justify-content: space-around;';
    }
  }}

  ${({ alignY }) => {
    switch (alignY) {
      case 'top':
        return 'align-items: flex-start;';
      case 'center':
        return 'align-items: center;';
      case 'bottom':
        return 'align-items: flex-end;';
      case 'stretch':
        return 'align-items: stretch;';
    }
  }}

  ${({ gap }) => {
    if (gap) {
      return `
        > * + * {
          margin-left: ${gap}px;
        }
      `;
    }
  }}
`;
